import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import Tooltip from "../Tooltip/Tooltip.js";
import './ButtonTooltip.css';/* empty css                   */
const ButtonTooltip = ({
  icon,
  onClick,
  className,
  children,
  onOpenChange,
  isOpen = false,
  clickableTooltipContent = "",
  hoverableTooltipContent = "",
  isActive = false
}) => {
  const [isClickableTooltipOpen, setIsClickableTooltipOpen] = useState(isOpen);
  const isShowClickableTooltip = !!clickableTooltipContent && isClickableTooltipOpen;
  const handleOpenChange = (visible) => {
    setIsClickableTooltipOpen(visible);
    return onOpenChange == null ? void 0 : onOpenChange(visible);
  };
  const button = /* @__PURE__ */ jsx(
    Button,
    {
      type: "link",
      className: classnames([
        "perxis-auto-button-tooltip__button",
        {
          "perxis-auto-button-tooltip__button--active": isActive
        }
      ]),
      onClick: (e) => {
        handleOpenChange(!isClickableTooltipOpen);
        return onClick == null ? void 0 : onClick(e);
      },
      iconPosition: "left",
      icon: /* @__PURE__ */ jsx(Icon, { name: icon, sticker: "button-tooltip-icon" }),
      children
    }
  );
  useEffect(() => {
    setIsClickableTooltipOpen(isOpen);
  }, [isOpen]);
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-button-tooltip", className), children: [
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        destroyTooltipOnHide: true,
        open: !!isShowClickableTooltip,
        title: clickableTooltipContent,
        onOpenChange: handleOpenChange,
        placement: "top",
        trigger: ["click"],
        className: classnames("perxis-auto-button-tooltip__clickable-tooltip"),
        triggerClassName: classnames([
          "perxis-auto-button-tooltip__trigger",
          {
            "perxis-auto-button-tooltip__trigger--hidden": !isShowClickableTooltip
          }
        ]),
        children: button
      }
    ),
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        destroyTooltipOnHide: true,
        title: hoverableTooltipContent,
        placement: "top",
        trigger: ["hover"],
        styles: {
          body: {
            display: isClickableTooltipOpen ? "none" : "flex"
          }
        },
        className: classnames("perxis-auto-button-tooltip__hoverable-tooltip"),
        triggerClassName: classnames([
          "perxis-auto-button-tooltip__trigger",
          {
            "perxis-auto-button-tooltip__trigger--hidden": isShowClickableTooltip
          }
        ]),
        arrow: !isClickableTooltipOpen,
        children: button
      }
    )
  ] });
};
export {
  ButtonTooltip as default
};
//# sourceMappingURL=ButtonTooltip.js.map
